import { takeLatest } from 'redux-saga/effects';
import {
  // Login
  LOGIN_REQUEST,
  // Logout
  LOGOUT_REQUEST,
  // User Profile
  GET_USER_REQUEST,
  UPDATE_PROFILE_REQUEST,
  RESET_PROFILE_FLAG,
  // Forgot Password
  FORGOT_PASSWORD_REQUEST,
  // Social Login
  SOCIAL_LOGIN_REQUEST,
  GET_OTP_REQUEST,
  LOGIN_WITH_PVS_REQUEST,
  GET_OTP_PVS_REQUEST,
  SIGNUP_REQUEST,
  GET_USER_DETAILS_REQUEST,
  GET_ADMIN_DASHBOARD_DATA_REQUEST,
  GET_ALL_INVOICES_REQUEST,
  GET_DASHBOARD_DATA_REQUEST,
} from '../../types/auth';

import {
  // Login
  loginWorker,
  // Register
  registerWorker,
  // Logout
  logoutWorker,
  // User Profile
  getUserWorker,
  updateProfileWorker,
  // Forgot Password
  forgotPasswordWorker,
  // Social Login
  socialLoginWorker,
  getOTPWorker,
  getOTPPVSWorker,
  signupWorker,
  getUserdetailsWorker,
  getAdminDashboardDataWorker,
  getAllInvoicesWorker,
  getDashboardDataWorker,
} from '../workers/authWorker';

/**
 * Auth Watcher Saga
 * Listens for auth actions and triggers the corresponding worker sagas
 */
export default function* authWatcher() {
  // GET OTP
  yield takeLatest(GET_OTP_REQUEST, getOTPWorker);
  
  // Login
  yield takeLatest(LOGIN_REQUEST, loginWorker);

  // Login with PVS
  yield takeLatest(GET_OTP_PVS_REQUEST, getOTPPVSWorker);
  
  // Register
  yield takeLatest(SIGNUP_REQUEST, signupWorker);

  yield takeLatest(GET_USER_DETAILS_REQUEST, getUserdetailsWorker);

  yield takeLatest(
    GET_ADMIN_DASHBOARD_DATA_REQUEST,
    getAdminDashboardDataWorker
  );

  yield takeLatest(GET_ALL_INVOICES_REQUEST, getAllInvoicesWorker);

  // Dashboard data
  yield takeLatest(GET_DASHBOARD_DATA_REQUEST, getDashboardDataWorker);
  
  // User Profile
  yield takeLatest(GET_USER_REQUEST, getUserWorker);
  yield takeLatest(UPDATE_PROFILE_REQUEST, updateProfileWorker);
  
  // Forgot Password
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordWorker);
  
  // Social Login
  yield takeLatest(SOCIAL_LOGIN_REQUEST, socialLoginWorker);
}
